import styled from "styled-components";

export const WorkOrderWrapper = styled.div`
div#react-select-2-placeholder {
    position: relative;
    top: 0px !important;
}
.search {
    width: 100%;
    min-width: 396px;
}
.select2-container {
    min-width: 153px;
    margin: 0px !important;
}
.date-item-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 3px;
    span {
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #535E63;
    &:not(:first-child){
      font-size: 10px;
      color: #989898;
      font-weight: 400;
    }
}
}
.two-line-ellipsis{
  height: auto !important;
}
svg.delete-icon {
    color: #D95040;
    font-size: 22px;
    cursor: pointer;
}
.action-icons{
    width: 22px;
 }
`;
